const go_under_login = {};

(function( $ ) {
	'use strict';

	go_under_login.init = function() {
		this.$login_form = $( 'body.login #login' );

		this.$login_form.find( 'input[type="text"], input[type="password"]' ).addClass( 'form-control' );
		this.$login_form.find( 'input[type="submit"]' ).addClass( 'btn btn-primary' );
		
		this.$login_form.find( '.forgetmenot, .pw-weak' ).addClass( 'form-check');
		this.$login_form.find( '.forgetmenot label, .pw-weak label' ).addClass( 'form-check-label');
		this.$login_form.find( '.forgetmenot input, .pw-weak input' ).addClass( 'form-check-input');
		
		this.$login_form.find( '.wp-generate-pw' ).addClass( 'btn' );
		
		this.$login_form.find( 'h1, #backtoblog' ).remove();
	};

	$( function() {
		go_under_login.init();
	});
})( jQuery );